import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "src/assets/imports/antdComponents";
import { StudyType } from "src/pages/NewAskKural/models/interfaces";
import MultiSelectStudyDropdown from "../../../MultiSelectStudyDropdown";

interface MultiSelectStudyDropdownWrapperProps {
	availableStudyTypeDropdownItems: any[];
	selectedType: StudyType[];
	isCompDisabled: boolean;
	isLoading: boolean;
	isStandardQueryMode: boolean;
	chatStarted: boolean;
	isProcessComplete: boolean;
	studyTypeFilterDisableItems: any[];
	onTypeChange: (value: StudyType[]) => void;
	isHomePage?: boolean;
}

const MultiSelectStudyDropdownWrapper: React.FC<MultiSelectStudyDropdownWrapperProps> = ({
	availableStudyTypeDropdownItems,
	selectedType,
	isCompDisabled,
	isLoading,
	isStandardQueryMode,
	chatStarted,
	isProcessComplete,
	studyTypeFilterDisableItems,
	onTypeChange,
	isHomePage = false,
}) => {
	const { t } = useTranslation();

	const isDisabled = useMemo(() => {
		return chatStarted && !isProcessComplete;
	}, [chatStarted, isProcessComplete]);

	return (
		<div
			className={`relative flex items-center justify-center ${
				selectedType?.length === 0 ? "min-w-[3.65rem] hover:min-w-[10.65rem]" : "min-w-[3.65rem]"
			} ${isDisabled ? "cursor-not-allowed" : ""}`}>
			<MultiSelectStudyDropdown
				availableStudyTypeDropdownItems={availableStudyTypeDropdownItems}
				selectedType={selectedType}
				handleTypeChange={onTypeChange}
				isCompDisabled={isCompDisabled}
				isLoading={isLoading}
				multiSelectLabel={"Study Type"}
				disabled={chatStarted || isDisabled}
				disabledItems={studyTypeFilterDisableItems}
				isHomePage={isHomePage}
			/>
			{selectedType?.length > 0 && <div className={`selected-type-dot ${chatStarted || isDisabled ? "disabled-dot" : ""}`}>{selectedType?.length}</div>}
		</div>
	);
};

export default MultiSelectStudyDropdownWrapper;
